import { useCallback, useMemo, useState } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import I18n from 'I18n';
import { getReportVisualType } from 'reporting-snowflake/relational/utils/report-utils';
import useFetchUserInfo from '../../../hooks/useFetchUserInfo';
import useSRVSnowflakeUpdater from '../../../hooks/relationalReports/useSRVSnowflakeUpdater';
import ChartTypeSelectableBoxes from '../components/ChartTypeSelectableBoxes';
import ChartTypeSelect from '../components/ChartTypeSelect';
import { useRelationalReportData } from '../../../contexts/RelationalReportContext';
import ErrorAlert from '../../shared-components/ErrorAlert';
import { getRelationalReportVisualTypeOptions, trackChartTypeChange } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const RelationalReportChartTypeToggleDropdown = ({
  onChange,
  report,
  excludedChartTypes = [],
  trackingApplicationName,
  trackingAssetType,
  trackingScreenName,
  useSelectableBoxesLayout,
  ['data-test-id']: dataTestId = 'chart-type-toggle'
}) => {
  const [error, setError] = useState(null);
  const userInfo = useFetchUserInfo();
  const {
    relationalReport
  } = useRelationalReportData();
  const {
    updateVisualType
  } = useSRVSnowflakeUpdater(report);
  const visualTypeOptions = useMemo(() => getRelationalReportVisualTypeOptions(excludedChartTypes), [excludedChartTypes]);
  const onChartTypeChange = useCallback(({
    target: {
      value
    }
  }) => {
    const {
      error: updateVisualError,
      updatedReport
    } = updateVisualType(value);
    if (updateVisualError) {
      setError(new Error(updateVisualError));
      return;
    }
    if (updatedReport) {
      trackChartTypeChange(value, trackingAssetType, trackingApplicationName, trackingScreenName);
      onChange(updatedReport);
    }
  }, [updateVisualType, onChange, trackingAssetType, trackingApplicationName, trackingScreenName]);
  if (!userInfo) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (visualTypeOptions.length < 2) {
    return null;
  }
  if (error) {
    return /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(ErrorAlert, {
        errorMessage: I18n.text('report-customization-components.customization-components.relational-report.metric-update-error'),
        error: error
      })
    });
  }
  const currentVisualType = getReportVisualType(relationalReport) || '';
  if (useSelectableBoxesLayout) {
    return /*#__PURE__*/_jsx(ChartTypeSelectableBoxes, {
      "data-test-id": dataTestId,
      value: currentVisualType,
      options: visualTypeOptions,
      onChartTypeChange: onChartTypeChange
    });
  }
  return /*#__PURE__*/_jsx(ChartTypeSelect, {
    "data-test-id": dataTestId,
    value: currentVisualType,
    options: visualTypeOptions,
    onChange: onChartTypeChange
  });
};
export default RelationalReportChartTypeToggleDropdown;